/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useStore } from '../Context';
import Navigation from '../components/Navigation/Navigation';
import { CAMERAS } from '../constants';
import useTheme from '../hooks/useTheme';
import loanlogs from '../services/loanlogs';

function Documents() {
  const { openModal, closeModal, stepForward, photoUri, setCamera, faceliveness_validation, setStep } = useStore();

  const theme = useTheme()
  
  function handleDocumentFrontPhoto () {
    setCamera({ open: true, type: CAMERAS.DNI_FRONT });
  }

  function handleDocumentBackPhoto () {
    setCamera({ open: true, type: CAMERAS.DNI_BACK });
  }
  
  function handleSubmit () {
    if (!photoUri.front   || !photoUri.back) return;
    if(faceliveness_validation) {
      setStep(7);
      return;
    }
    stepForward();
  };

  useEffect(() => {
    if (photoUri.front || photoUri.back) return;
    loanlogs.success('/documents').catch(console.log)
    openModal({ type: 'document' });
    return () => closeModal();
  }, []);

  return (
    <main className='page-step page-step-documents'>
      <Navigation />
      <header className='page-header'>
        <h1>Fotos de tu DNI</h1>
        <p>
          Presioná en los recuadros para tomar cada fotografía.
        </p>
      </header>
      <div className="page-content">
        <div className='frame' onClick={handleDocumentFrontPhoto}>
            {photoUri.front 
                ? (<img className='frame-image' src={photoUri.front} alt="foto del frente de un documento" />) 
                : (
                    <>
                        <img src={`/${theme}/document-front.svg`} alt="ilustracion del frente de un documento"/>
                        <p className='text-center text-balance mx-2'>
                            <strong>Presioná acá</strong> para tomar la foto del <strong>frente</strong> de tu DNI
                        </p>
                    </>
                )
            }
        </div>
        <div className='frame' onClick={handleDocumentBackPhoto}>
            {photoUri.back 
                ? (<img className='frame-image' src={photoUri.back} alt="foto del reverso de un documento" />) 
                : (
                    <>
                        <img src={`/${theme}/document-back.svg`} alt="ilustracion del reverso de un documento" />
                        <p className='text-center text-balance mx-2'>
                            <strong>Presioná</strong> para tomar la 
                            foto del <strong>dorso</strong> de tu DNI
                        </p>
                    </>
                )
            }
        </div>
      </div>
      <div className="page-actions flex-column">
        <button  className='button-primary'  onClick={handleSubmit}>
            Continuar
        </button>
      </div>
    </main>
  );
}

export default Documents;
